import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { offeringsKeys } from './browseQueryKeys'
import { addBookmark, removeBookmark } from './browseEndpoints'

export interface ToggleBookmarkPayload {
  propertyId: string
  isCurrentlyBookmarked: boolean
}

export function useToggleBookmarkMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ propertyId, isCurrentlyBookmarked }: ToggleBookmarkPayload) =>
      isCurrentlyBookmarked ? removeBookmark(propertyId) : addBookmark(propertyId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: offeringsKeys.lists() })
      // Dashboard featured strip reads the same rows under its own key.
      qc.invalidateQueries({ queryKey: offeringsKeys.featuredAll() })
    },
  })
}
